import { createContext } from 'react';

export interface CmpContextValue {
  consentGiven: boolean;
}

export const CmpContext = createContext<CmpContextValue | undefined>(undefined);
